import { useClientQuery } from "@graphql/clients/clients.g";

import { Box } from "@design-system/Box/Box";
import { OptionComponentProps } from "@design-system/Select/Select";
import { Text } from "@design-system/Text/Text";

type Props = OptionComponentProps;

/**
 * Handles the display of client ID values in a select component.
 */
export const SelectClientOption = ({ id }: Props) => {
  const clientQuery = useClientQuery({ clientId: id });

  const client = clientQuery.data?.client;

  return (
    <Box gap={4} align="center">
      <Text>{client?.name}</Text>
    </Box>
  );
};
